export type PaginatedResponse<T> = {
    hasMore: boolean;
    page: number;
    total: number;
    items: T[];
}

export type PaginatedResponseV2<T> = {
    results: T[]
    totalResults?: number
    totalPages?: number
    currentPage: number
    hasMore?: boolean
}

export function convertV1ToV2<T>(
    v1: PaginatedResponse<T>,
    pageSize: number
): PaginatedResponseV2<T> {
    const totalPages = Math.ceil(v1.total / pageSize);

    return {
        results: v1.items,
        totalResults: v1.total,
        totalPages,
        currentPage: v1.page,
        hasMore: v1.hasMore,
    };
}